var _excluded = ["titleClass", "buttonVertical", "arrowEnable", "arrowHandler", "direction", "isMobile", "size", "confirmBtnDisabled", "title", "subTitle", "open", "className", "overlayClassName", "zIndex", "onOk", "onCancel", "titleCenter", "wrapClassName", "contextWrapper", "width", "height", "okText", "type", "footerWrapper", "headerWrapper", "cancelText", "footer", "closable"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react/no-unknown-property */
import { Button } from "../button";
import { cn } from "../../../lib/utils";
import { CloseIcon, DirectionleftIcon } from '@bfe/moly-icons';
import { IconButton } from "../iconbutton";
import * as Dialog from '@radix-ui/react-dialog';
import React, { useEffect, useState } from 'react';
import * as styles from "../../style/modal";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Footer = function Footer(_ref) {
  var size = _ref.size,
    buttonVertical = _ref.buttonVertical,
    isMobile = _ref.isMobile,
    onOk = _ref.onOk,
    onCancel = _ref.onCancel,
    okText = _ref.okText,
    cancelText = _ref.cancelText,
    footer = _ref.footer,
    footerWrapper = _ref.footerWrapper,
    confirmBtnDisabled = _ref.confirmBtnDisabled;
  if (footer === false || footer === null) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  if (footer) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        marginTop: 24
      },
      className: cn({
        'px-[24px]': isMobile || size === 'small',
        'px-[32px]': size !== 'small' && !isMobile
      }, footerWrapper),
      children: footer
    });
  }
  return /*#__PURE__*/_jsx("div", {
    style: {
      display: 'flex',
      marginTop: 24,
      justifyContent: 'center'
    },
    className: cn({
      'px-[24px]': isMobile || size === 'small',
      'max-w-[496px] mx-auto': ['large', 'medium'].includes(size) && !isMobile
    }),
    children: /*#__PURE__*/_jsx(Dialog.Close, {
      asChild: true,
      children: /*#__PURE__*/_jsxs("div", {
        className: cn('flex w-full', footerWrapper, {
          'flex-col gap-[12px]': isMobile && buttonVertical,
          'gap-[20px]': isMobile && !buttonVertical || !isMobile
        }),
        children: [okText && /*#__PURE__*/_jsx(Button, {
          className: "flex-1",
          disabled: confirmBtnDisabled,
          variant: "primary",
          onClick: function onClick() {
            onOk === null || onOk === void 0 ? void 0 : onOk();
          },
          children: okText
        }), cancelText && /*#__PURE__*/_jsx(Button, {
          className: "flex-1",
          variant: "secondary",
          onClick: function onClick() {
            onCancel === null || onCancel === void 0 ? void 0 : onCancel();
          },
          children: cancelText
        })]
      })
    })
  });
};
var Modal = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var titleClass = _ref2.titleClass,
    buttonVertical = _ref2.buttonVertical,
    arrowEnable = _ref2.arrowEnable,
    arrowHandler = _ref2.arrowHandler,
    _ref2$direction = _ref2.direction,
    direction = _ref2$direction === void 0 ? 'default' : _ref2$direction,
    isMobile = _ref2.isMobile,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'medium' : _ref2$size,
    confirmBtnDisabled = _ref2.confirmBtnDisabled,
    title = _ref2.title,
    subTitle = _ref2.subTitle,
    open = _ref2.open,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    _ref2$overlayClassNam = _ref2.overlayClassName,
    overlayClassName = _ref2$overlayClassNam === void 0 ? '' : _ref2$overlayClassNam,
    _ref2$zIndex = _ref2.zIndex,
    zIndex = _ref2$zIndex === void 0 ? 1000 : _ref2$zIndex,
    onOk = _ref2.onOk,
    onCancel = _ref2.onCancel,
    titleCenter = _ref2.titleCenter,
    wrapClassName = _ref2.wrapClassName,
    contextWrapper = _ref2.contextWrapper,
    width = _ref2.width,
    height = _ref2.height,
    _ref2$okText = _ref2.okText,
    okText = _ref2$okText === void 0 ? 'Ok' : _ref2$okText,
    type = _ref2.type,
    _ref2$footerWrapper = _ref2.footerWrapper,
    footerWrapper = _ref2$footerWrapper === void 0 ? '' : _ref2$footerWrapper,
    _ref2$headerWrapper = _ref2.headerWrapper,
    headerWrapper = _ref2$headerWrapper === void 0 ? '' : _ref2$headerWrapper,
    _ref2$cancelText = _ref2.cancelText,
    cancelText = _ref2$cancelText === void 0 ? 'Cancel' : _ref2$cancelText,
    footer = _ref2.footer,
    _ref2$closable = _ref2.closable,
    closable = _ref2$closable === void 0 ? true : _ref2$closable,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useState = useState(open),
    _useState2 = _slicedToArray(_useState, 2),
    openBool = _useState2[0],
    setOpenBool = _useState2[1];
  var iconMap = {
    successful: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2IDlDMjEuMDg4IDkgOSAyMS4wODggOSAzNnMxMi4wODggMjcgMjcgMjcgMjctMTIuMDg4IDI3LTI3UzUwLjkxMiA5IDM2IDlaTTMgMzZDMyAxNy43NzUgMTcuNzc1IDMgMzYgM3MzMyAxNC43NzUgMzMgMzMtMTQuNzc1IDMzLTMzIDMzUzMgNTQuMjI1IDMgMzZaIiBmaWxsPSIjMjBCMjZDIiBmaWxsLW9wYWNpdHk9Ii4xNiIvPjxjaXJjbGUgY3g9IjM2IiBjeT0iMzYiIHI9IjMzIiBmaWxsPSIjMjBCMjZDIiBmaWxsLW9wYWNpdHk9Ii4xNiIvPjxwYXRoIGQ9Ik01MS41OTQgMjYuMzUyYTMgMyAwIDAgMSAuMDU0IDQuMjQybC0xNy41MyAxNy45OGEzLjAzIDMuMDMgMCAwIDEtNC4yNTguMDc4bC05LjQyOS04Ljk4YTMgMyAwIDEgMSA0LjEzOC00LjM0NGw3LjMwMyA2Ljk1NSAxNS40OC0xNS44NzdhMyAzIDAgMCAxIDQuMjQyLS4wNTRaIiBmaWxsPSIjMjBCMjZDIi8+PC9zdmc+',
    failed: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2IDlDMjEuMDg4IDkgOSAyMS4wODggOSAzNnMxMi4wODggMjcgMjcgMjcgMjctMTIuMDg4IDI3LTI3UzUwLjkxMiA5IDM2IDlaTTMgMzZDMyAxNy43NzUgMTcuNzc1IDMgMzYgM3MzMyAxNC43NzUgMzMgMzMtMTQuNzc1IDMzLTMzIDMzUzMgNTQuMjI1IDMgMzZaIiBmaWxsPSIjRUY0NTRBIiBmaWxsLW9wYWNpdHk9Ii4xNiIvPjxjaXJjbGUgY3g9IjM2IiBjeT0iMzYiIHI9IjMzIiBmaWxsPSIjRUY0NTRBIiBmaWxsLW9wYWNpdHk9Ii4xNiIvPjxwYXRoIGQ9Ik00Ny4xMjEgMjQuODc5YTMgMyAwIDAgMSAwIDQuMjQybC0xOCAxOGEzIDMgMCAxIDEtNC4yNDItNC4yNDJsMTgtMThhMyAzIDAgMCAxIDQuMjQyIDBaIiBmaWxsPSIjRUY0NTRBIi8+PHBhdGggZD0iTTI0Ljg3OSAyNC44NzlhMyAzIDAgMCAxIDQuMjQyIDBsMTggMThhMyAzIDAgMSAxLTQuMjQyIDQuMjQybC0xOC0xOGEzIDMgMCAwIDEgMC00LjI0MloiIGZpbGw9IiNFRjQ1NEEiLz48L3N2Zz4=',
    alert: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2IDlDMjEuMDg4IDkgOSAyMS4wODggOSAzNnMxMi4wODggMjcgMjcgMjcgMjctMTIuMDg4IDI3LTI3UzUwLjkxMiA5IDM2IDlaTTMgMzZDMyAxNy43NzUgMTcuNzc1IDMgMzYgM3MzMyAxNC43NzUgMzMgMzMtMTQuNzc1IDMzLTMzIDMzUzMgNTQuMjI1IDMgMzZaIiBmaWxsPSIjRjdBNjAwIiBmaWxsLW9wYWNpdHk9Ii4xNiIvPjxjaXJjbGUgY3g9IjM2IiBjeT0iMzYiIHI9IjMzIiBmaWxsPSIjRjdBNjAwIiBmaWxsLW9wYWNpdHk9Ii4xNiIvPjxwYXRoIGQ9Ik0zNiAyMWEzIDMgMCAwIDEgMyAzdjEyYTMgMyAwIDEgMS02IDBWMjRhMyAzIDAgMCAxIDMtM1pNMzMgNDhhMyAzIDAgMCAxIDMtM2guMDNhMyAzIDAgMSAxIDAgNkgzNmEzIDMgMCAwIDEtMy0zWiIgZmlsbD0iI0Y3QTYwMCIvPjwvc3ZnPg==',
    pending: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2IDlDMjEuMDg4IDkgOSAyMS4wODggOSAzNnMxMi4wODggMjcgMjcgMjcgMjctMTIuMDg4IDI3LTI3UzUwLjkxMiA5IDM2IDlaTTMgMzZDMyAxNy43NzUgMTcuNzc1IDMgMzYgM3MzMyAxNC43NzUgMzMgMzMtMTQuNzc1IDMzLTMzIDMzUzMgNTQuMjI1IDMgMzZaIiBmaWxsPSIjQzBEMkU3IiBmaWxsLW9wYWNpdHk9Ii4xMiIvPjxjaXJjbGUgY3g9IjM2IiBjeT0iMzYiIHI9IjMzIiBmaWxsPSIjQzBEMkU3IiBmaWxsLW9wYWNpdHk9Ii4xMiIvPjxwYXRoIGQ9Ik0zNCAxN2MxLjY1NyAwIDMgMS4yOSAzIDIuODh2MTguMjRjMCAxLjU5LTEuMzQzIDIuODgtMyAyLjg4cy0zLTEuMjktMy0yLjg4VjE5Ljg4YzAtMS41OSAxLjM0My0yLjg4IDMtMi44OFoiIGZpbGw9IiMxMjEyMTQiLz48cGF0aCBkPSJNNTUgMzhjMCAxLjY1Ny0xLjYxMiAzLTMuNiAzSDM0LjZjLTEuOTg4IDAtMy42LTEuMzQzLTMuNi0zczEuNjEyLTMgMy42LTNoMTYuOGMxLjk4OCAwIDMuNiAxLjM0MyAzLjYgM1oiIGZpbGw9IiMxMjEyMTQiLz48L3N2Zz4='
  };
  useEffect(function () {
    if (open) {
      setTimeout(function () {
        document.body.style.pointerEvents = 'initial';
      }, 100);
    }
    if (open) {
      setOpenBool(open);
    } else {
      setTimeout(function () {
        setOpenBool(open);
      }, 300);
    }
    return function () {};
  }, [open, setOpenBool]);
  var modalWidth = width;
  if (isMobile) {
    modalWidth = 'calc(100vw - 16px)';
    if (direction === 'bottom') {
      modalWidth = '100vw';
    }
  }
  return /*#__PURE__*/_jsx(Dialog.Root, {
    open: openBool,
    children: /*#__PURE__*/_jsxs(Dialog.Portal, {
      children: [/*#__PURE__*/_jsx(Dialog.Overlay, {
        style: {
          zIndex: zIndex
        },
        className: cn(styles.molyModalOpen, overlayClassName, !open ? styles.molyModalClose : '')
      }), /*#__PURE__*/_jsxs(Dialog.Content, {
        style: {
          width: modalWidth,
          height: height,
          zIndex: zIndex + 1
        },
        "data-open": open ? 'open' : 'closed',
        "data-direction": direction,
        className: cn('moly-modal py-[24px] rounded-2xl', {
          'rounded-t-2xl': isMobile && direction === 'bottom',
          'rounded-b-none': isMobile && direction === 'bottom',
          'w-[780px]': !isMobile && !width && size === 'large',
          'w-[560px]': !isMobile && !width && size === 'medium',
          'w-[480px]': !isMobile && !width && size === 'small'
        }, styles.molyModalContainer, className),
        onEscapeKeyDown: onCancel,
        children: [/*#__PURE__*/_jsx("div", {
          className: cn('text-[18px] w-full leading-[26px] font-semibold flex flex-row-reverse', {
            'px-[32px]': !isMobile,
            'px-[24px]': isMobile || size === 'small',
            'text-right': true,
            'text-[20px] leading-[28px] mr-[0px]': type,
            hidden: !title && !closable
          }),
          children: closable && type && /*#__PURE__*/_jsx(Dialog.Close, {
            asChild: true,
            children: /*#__PURE__*/_jsx(IconButton, {
              width: "24px",
              className: "w-[24px] h-[24px]",
              children: /*#__PURE__*/_jsx(CloseIcon, {
                "aria-label": "Close",
                onClick: function onClick() {
                  onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                },
                className: cn('IconButton  leading-6 rounded inline-block text-[#81858c]  ')
              })
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: cn(headerWrapper),
          children: [type && /*#__PURE__*/_jsx("div", {
            className: cn('text-center'),
            children: /*#__PURE__*/_jsx("img", {
              className: cn('w-[66px] h-[66px] mb-[16px] inline'),
              src: iconMap[type],
              alt: "success"
            })
          }), /*#__PURE__*/_jsxs(Dialog.Title, {
            className: cn('text-[18px] leading-[26px] font-semibold flex gap-x-2', {
              'px-[32px]': !isMobile,
              'px-[24px]': isMobile || size === 'small',
              'text-center': titleCenter,
              'text-[20px] leading-[28px] mr-[0px]': type,
              hidden: !title && !closable,
              'justify-end': !title
            }, titleClass),
            children: [arrowEnable && /*#__PURE__*/_jsx(IconButton, {
              width: "24px",
              className: cn('w-[24px] h-[24px] hidden'),
              children: /*#__PURE__*/_jsx(DirectionleftIcon, {
                onClick: function onClick() {
                  arrowHandler === null || arrowHandler === void 0 ? void 0 : arrowHandler();
                }
              })
            }), title && /*#__PURE__*/_jsx("div", {
              className: "flex-1",
              children: title
            }), closable && !type && /*#__PURE__*/_jsx(Dialog.Close, {
              asChild: true,
              children: /*#__PURE__*/_jsx(IconButton, {
                width: "24px",
                className: "w-[24px] h-[24px] ",
                children: /*#__PURE__*/_jsx(CloseIcon, {
                  "aria-label": "Close",
                  onClick: function onClick() {
                    onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                  },
                  className: cn('IconButton leading-6 rounded inline-block text-[#81858c] ')
                })
              })
            })]
          }), subTitle && /*#__PURE__*/_jsx(Dialog.Title, {
            className: cn('mt-[8px] text-[16px] leading-[24px] font-normal text-[#81858C] ', {
              'text-center': titleCenter
            }),
            children: subTitle
          })]
        }), /*#__PURE__*/_jsx("div", {
          ref: ref,
          className: cn(contextWrapper, styles.molyModalContent, title ? '' : 'unhave-header', {
            'px-[32px]': !isMobile,
            'px-[24px]': isMobile,
            'overflow-y-scroll max-h-[440px]': isMobile
          }, wrapClassName),
          children: props === null || props === void 0 ? void 0 : props.children
        }), /*#__PURE__*/_jsx(Footer, {
          size: size,
          buttonVertical: buttonVertical,
          isMobile: isMobile,
          footerWrapper: footerWrapper,
          confirmBtnDisabled: confirmBtnDisabled,
          footer: footer,
          onOk: onOk,
          onCancel: onCancel,
          okText: okText,
          cancelText: cancelText
        })]
      })]
    })
  });
});
Modal.displayName = 'Modal';
export { Modal };